export const SALES_PLAYGROUND_PUBLIC_PATH = "/demo/sales-playground";

export type RestaurantCustomerSurface = "home" | "menu" | "order" | "reservation" | "assistant";

const SURFACE_SEGMENTS: Readonly<Record<Exclude<RestaurantCustomerSurface, "home">, string>> = Object.freeze({
  menu: "carta",
  order: "pedir",
  reservation: "reservar",
  assistant: "asistente",
});

export function restaurantCustomerPath(slug: string, surface: RestaurantCustomerSurface = "home"): string {
  const base = `${SALES_PLAYGROUND_PUBLIC_PATH}/${encodeURIComponent(slug)}`;
  const segment = surface === "home" ? "" : `/${SURFACE_SEGMENTS[surface]}`;
  return `${base}${segment}?vertical=gastronomia`;
}

export function parseRestaurantCustomerPath(pathname: string): {
  readonly businessSlug: string | null;
  readonly surface: RestaurantCustomerSurface;
} {
  const suffix = pathname.startsWith(SALES_PLAYGROUND_PUBLIC_PATH)
    ? pathname.slice(SALES_PLAYGROUND_PUBLIC_PATH.length).replace(/^\/+|\/+$/g, "")
    : "";
  const [rawSlug, rawSurface] = suffix.split("/");
  let businessSlug: string | null = null;
  if (rawSlug) {
    try { businessSlug = decodeURIComponent(rawSlug); }
    catch { businessSlug = rawSlug; }
  }
  const surface = rawSurface === "carta"
    ? "menu"
    : rawSurface === "pedir"
      ? "order"
      : rawSurface === "reservar"
        ? "reservation"
        : rawSurface === "asistente"
          ? "assistant"
          : "home";
  return Object.freeze({ businessSlug, surface });
}
